"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var types_1 = __importDefault(require("../types"));
function chatCleanReducer(state, action) {
    switch (action.type) {
        case types_1["default"].RUN_CLEANER: {
            var rooms = state.rooms, users = state.users;
            var roomsArr = lodash_1["default"].toArray(rooms);
            var roomsSorted = lodash_1["default"].sortBy(roomsArr, function (item) { return item.updatedAt; }).reverse();
            var roomsReserved_1 = roomsSorted.slice(0, 100);
            var roomsForDeleting = roomsSorted.slice(100, roomsSorted.length);
            roomsForDeleting = roomsForDeleting.filter(function (item) { return item.unread; });
            // console.log('cleaner', roomsArr, roomsReserved, roomsForDeleting)
            var roomsIds_1 = [];
            var usersIds_1 = [];
            lodash_1["default"].forEach(roomsForDeleting, function (room) {
                roomsIds_1.push(room._id);
                if (room.userId)
                    usersIds_1.push(room.userId);
            });
            var thresholdMoment_1 = moment_1["default"]().add(-1, 'week');
            lodash_1["default"].mapValues(users, function (user) {
                if (lodash_1["default"].find(roomsReserved_1, function (item) { return item.userId === user._id; }))
                    return null;
                if (thresholdMoment_1.isBefore(moment_1["default"](user.storeUpdatedAt)))
                    return null;
                usersIds_1.push(user._id);
            });
            usersIds_1 = lodash_1["default"].uniq(usersIds_1);
            // console.log('[CHAT cleaner] deleting rooms:', roomsIds.length)
            // console.log('[CHAT cleaner] deleting users:', usersIds.length)
            rooms = rooms.without.apply(rooms, roomsIds_1);
            users = users.without.apply(users, usersIds_1);
            return state.merge({ rooms: rooms, users: users });
        }
        default:
            return state;
    }
}
exports["default"] = chatCleanReducer;
